import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction} from "lodash";
import { initialFilter } from "./WixCategoriesUIHelper";
const WixCategoriesUIContext = createContext();

export function useWixCategoriesUIContext() {
  return useContext(WixCategoriesUIContext);
}

export const WixCategoriesUIConsumer = WixCategoriesUIContext.Consumer;

export function WixCategoriesUIProvider({ wixCategoriesUIEvents, children }) {

  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  // Query Params set when do pagination ,filter,search
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const [ids, setIds] = useState([]);

  const value = {
    ids,
    setIds,
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    openEditWixCategoryPage: wixCategoriesUIEvents.openEditWixCategoryPage,
    openViewWixCategoryPage: wixCategoriesUIEvents.openViewWixCategoryPage
   
  };

  return (
    <WixCategoriesUIContext.Provider value={value}>{children}</WixCategoriesUIContext.Provider>
  );
}
